module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Would you like to delete the task \"" + _vm._s(_vm.task.id) + " - " + _vm._s(_vm.task.subject) + "\"?")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui red basic cancel inverted button",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n\t\t\tNo\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n\t\t\tYes\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("\n\t\tDelete Task\n\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4af38bfd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirmDialog.vue
// module id = 248
// module chunks = 1